(function() {
  window.Document = (function() {
    function Document() {}

    Document.setup = function() {
      return Document.decorate();
    };

    Document.decorate = function() {
      var alertApprovalFailure = function(xhr) {
        if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
          alert(xhr.responseJSON.errors.join("\n"));
        }
      };
      $(".js-document-form").on('click', '.js-document-form-type', function(e) {
        if ($(this).val() === "right_to_work") {
          $(".js-document-form").find(".js-document-form-expiry").show();
        } else {
          $(".js-document-form").find(".js-document-form-expiry").hide();
        }
        if (["passport", "birth_certificate", "drivers_licence"].indexOf($(this).val()) >= 0) {
          $(".js-document-form").find(".js-document-form-id-origin").show();
        } else {
          $(".js-document-form").find(".js-document-form-id-origin").hide();
        }
        if ($(this).val() === "access_ni") {
          $(".js-document-form").find(".js-document-form-issued").show();
        } else {
          $(".js-document-form").find(".js-document-form-issued").hide();
        }
        if ($(this).val() === "release" || $(this).val() === "other") {
          $(".js-document-form").find(".js-document-form-production").show();
        } else {
          $(".js-document-form").find(".js-document-form-production").hide();
        }
        if ($(this).val() === "other") {
          $(".js-document-form").find(".js-document-form-visible").show();
          return $(".js-document-form").find(".js-document-form-name").show();
        } else {
          $(".js-document-form").find(".js-document-form-visible").hide();
          return $(".js-document-form").find(".js-document-form-name").hide();
        }
      });
      $(document).on('click', '.js-document-preview', function(e) {
        var $link, url, ext, isImage, isPdf;
        e.preventDefault();
        e.stopPropagation();
        $link = $(this);
        url = $link.data('url');
        if (!url) {
          console.error('No URL found for preview');
          return false;
        }
        // Download links redirect to S3, so the extension comes from the filename.
        ext = ($link.data('filename') || url).split('.').pop().toLowerCase().split('?')[0];
        isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].indexOf(ext) >= 0;
        isPdf = ext === 'pdf';

        if (typeof $.magnificPopup === 'undefined') {
          console.error('Magnific Popup not loaded');
          window.open(url, '_blank');
          return false;
        }

        if (isImage) {
          $.magnificPopup.open({
            items: {
              src: url,
              type: 'image'
            },
            closeOnContentClick: true,
            image: {
              verticalFit: true
            }
          });
        } else if (isPdf) {
          $.magnificPopup.open({
            items: {
              src: '<div class="pdf-preview-modal"><iframe src="' + url + '" width="100%" height="100%" frameborder="0"></iframe></div>',
              type: 'inline'
            },
            callbacks: {
              open: function() {
                $('.mfp-content').css({
                  'width': '90%',
                  'height': '90vh',
                  'max-width': '1200px'
                });
              }
            }
          });
        } else {
          window.open(url, '_blank');
        }
        return false;
      });

      $(".js-documents").on('click', '.js-document-reject', function(e) {
        var $link, $reasons;
        e.preventDefault();
        $link = $(this);
        if ($link.data("type") === "access_ni") {
          $reasons = $("#cert_reasons");
        } else {
          $reasons = $("#identification_reasons");
        }
        $reasons.addClass("js-document-reasons");
        $reasons.find("form").prop("action", $link.prop("href"));
        $reasons.find("input").prop('checked', '');
        $reasons.find("input[type='submit']").prop('disabled', '');
        return $.magnificPopup.open({
          items: {
            src: $reasons,
            type: "inline"
          },
          cache: false
        });
      });
      $(".js-documents").on('click', '.js-document-approve', function(e) {
        var $accessNi, $link;
        e.preventDefault();
        $link = $(this);
        if ($link.data("type") === "access_ni") {
          e.preventDefault();
          $accessNi = $("#access_ni_cert").addClass("js-document-reasons");
          $accessNi.find("form").prop("action", $link.prop("href"));
          $accessNi.find("input.form-control").val($link.data('issued'));
          $accessNi.find("input[type='submit']").prop('disabled', '');
          return $.magnificPopup.open({
            items: {
              src: $accessNi,
              type: "inline"
            },
            cache: false
          });
        } else if ($link.data("type") === "right_to_work") {
          var $rtwExpiry = $("#rtw_expiry").addClass("js-document-reasons");
          $rtwExpiry.find("form").prop("action", $link.prop("href"));
          $rtwExpiry.find("input.form-control").val($link.data('expired') || "");
          $rtwExpiry.find("input[type='submit']").prop('disabled', '');
          return $.magnificPopup.open({
            items: {
              src: $rtwExpiry,
              type: "inline"
            },
            cache: false
          });
        } else {
          return $.ajax({
            method: "POST",
            url: $link.attr('href'),
            dataType: "json",
            success: function(data) {
              return $(".document-row[data-document=" + data.id + "]").remove();
            },
            error: alertApprovalFailure
          });
        }
      });
      return $(document).on('submit', '.js-document-reasons form', function(e) {
        var $form;
        $form = $(this);
        $.ajax({
          method: "POST",
          url: $form.attr('action'),
          dataType: "json",
          data: $form.serialize(),
          success: function(data) {
            $(".document-row[data-document=" + data.id + "]").remove();
            return $.magnificPopup.close();
          },
          error: alertApprovalFailure
        });
        e.preventDefault();
        return false;
      });
    };

    return Document;

  })();

}).call(this);